/**
 * selectors/locales.ts
 * desc: selectors for locales
 * note:
 */

import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from '../index';

const selectLocales = (state: RootState) => state.locales;

export const selectCurrentLocale = createSelector(selectLocales, (locales) => {
    return locales.locale;
});
